/**
 * 사용자 정보 입력 검증 및 포맷팅 헬퍼
 */

// 이메일 정규식 (아이디 검증용)
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

// 아이디·이름·소속 최대 글자 수 (DB 컬럼 tb_user.user_id·user_name·organization 길이와 같음)
export const EMAIL_MAX_LENGTH = 100
export const NAME_MAX_LENGTH = 100
export const ORGANIZATION_MAX_LENGTH = 100

/**
 * 아이디 (이메일) 형식 검증
 */
export function isValidEmail(email: string): boolean {
  if (!email) return false
  return EMAIL_REGEX.test(email.trim())
}

/**
 * 이름 검증 (1자 이상 NAME_MAX_LENGTH자 이내)
 */
export function isValidName(name: string): boolean {
  const trimmed = (name || '').trim()
  return trimmed.length > 0 && trimmed.length <= NAME_MAX_LENGTH
}

/**
 * 소속 기관 / 부서 검증 (ORGANIZATION_MAX_LENGTH자 이내)
 */
export function isValidOrganization(org: string): boolean {
  const trimmed = (org || '').trim()
  return trimmed.length <= ORGANIZATION_MAX_LENGTH
}

/**
 * 비밀번호 검증 (최소 4자 이상 30자 이내)
 */
export function isValidPassword(password: string): boolean {
  if (!password) return false
  return password.length >= 4 && password.length <= 30
}

/**
 * 숫자 이외의 문자를 제거
 */
export function stripDigits(value: string): string {
  if (!value) return ''
  return value.replace(/[^0-9]/g, '')
}

/**
 * 휴대전화 번호 하이픈(-) 자동 연결 포맷터
 * 예: 01012345678 -> 010-1234-5678
 *     0101234567  -> 010-123-4567
 */
export function formatPhoneNo(value: string): string {
  if (!value) return ''
  const nums = stripDigits(value).slice(0, 11) // 최대 11자리 제한
  if (nums.length <= 3) return nums
  if (nums.length <= 7) {
    return `${nums.slice(0, 3)}-${nums.slice(3)}`
  }
  return `${nums.slice(0, 3)}-${nums.slice(3, nums.length - 4)}-${nums.slice(nums.length - 4)}`
}

/**
 * 휴대전화 번호 형식 검증 (010, 011, 016, 017, 018, 019 등 10~11자리 휴대전화 번호)
 */
export function isValidPhoneNo(value: string): boolean {
  if (!value || !value.trim()) return true // 비어있으면 통과 (선택 입력)
  const nums = stripDigits(value)
  return /^01[016789]\d{7,8}$/.test(nums)
}
